import type React from 'react';
import { useId } from 'react';
import { useTranslate } from 'ra-core';
import { Input } from '../../components/ui/input';

interface DateRangeFilterProps {
  startDate: string;
  endDate: string;
  setStartDate: (date: string) => void;
  setEndDate: (date: string) => void;
  minDate?: string;
  maxDate?: string;
}

/**
 * Start/end date inputs. Callers' queries are keyed by the dates, so they refetch with the new range on change.
 */
export const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  minDate,
  maxDate = new Date().toISOString().split('T')[0],
}) => {
  const translate = useTranslate();
  const startDateId = useId();
  const endDateId = useId();

  return (
    <div className="flex flex-wrap items-end gap-2">
      <label className="grid gap-1 text-xs font-medium" htmlFor={startDateId}>
        {translate('moonstar.dateRange.startDate')}
        <Input
          id={startDateId}
          className="w-[150px]"
          type="date"
          value={startDate}
          min={minDate}
          max={maxDate}
          onChange={(event) => setStartDate(event.target.value)}
        />
      </label>
      <label className="grid gap-1 text-xs font-medium" htmlFor={endDateId}>
        {translate('moonstar.dateRange.endDate')}
        <Input
          id={endDateId}
          className="w-[150px]"
          type="date"
          value={endDate}
          min={minDate}
          max={maxDate}
          onChange={(event) => setEndDate(event.target.value)}
        />
      </label>
    </div>
  );
};
